import { MutationTree, ActionTree, Module } from 'vuex';
import Axios from 'axios';
import SignUpCommand from './SignUpCommand';

export interface SignUpState {
  status: string;
}

const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
const SIGNUP_ERROR = 'SIGNUP_ERROR';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';

const signUpState: SignUpState = {
  status: '',
};

const mutations: MutationTree<SignUpState> = {
  [SIGNUP_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [SIGNUP_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [SIGNUP_ERROR]: (state) => {
    state.status = 'error';
  },
};

const actions: ActionTree<SignUpState, object> = {
  [SIGNUP_REQUEST]: ({ commit }, command: SignUpCommand) => new Promise<void>((resolve, reject) => {
    commit(SIGNUP_REQUEST);

    Axios.post<void>('users', command)
      .then(() => {
        commit(SIGNUP_SUCCESS);

        return resolve();
      })
      .catch(() => {
        commit(SIGNUP_ERROR);

        return reject();
      });
  }),
};

const signUpModule: Module<SignUpState, object> = {
  state: signUpState,
  mutations,
  actions,
};

export default signUpModule;
